export const BuyerRequests = [
    {
        request_type: 'Add New Supplier',
        label: 'Add New Supplier',
        value: 'add_supplier',
        categories: [],
    },
    {
        request_type: 'Amend 129 Knots SO Details',
        label: 'Amend 129 Knots SO Details',
        value: '129_knots_so',
        categories: [
            {
                value: 'deal_specific_tcs',
                label: 'Deal Specific T&Cs',
                sub_categories: [
                    {
                        value: 'other',
                        label: 'Other',
                    },
                ],
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend BDN',
        label: 'Amend BDN',
        value: 'bdn',
        categories: [
            {
                value: 'wrong_file_uploaded',
                label: 'Wrong file uploaded',
            },
            {
                value: 'incorrect_information',
                label: 'Incorrect information',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Buyer PO',
        label: 'Amend Buyer PO',
        value: 'buyer_po',
        categories: [
            {
                value: 'wrong_file_uploaded',
                label: 'Wrong file uploaded',
            },
            {
                value: 'incorrect_information',
                label: 'Incorrect information',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Deal Confirmation',
        label: 'Amend Deal Confirmation',
        value: 'amend_deal_confirmation',
        categories: [
            {
                value: 'rfq_details',
                label: 'RFQ details',
            },
            {
                value: 'agent_details',
                label: 'Agent Details',
            },
            {
                value: 'quantity_offer_details',
                label: 'Offer Details - Quantity',
            },
            {
                value: 'product_quality_offer_details',
                label: 'Offer Details - Product/Quality',
            },
            {
                value: 'price_offer_details',
                label: 'Offer Details - Price/unit',
            },
            {
                value: 'deal_specific_tcs',
                label: 'Deal Specific T&Cs',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Invoice',
        label: 'Amend Invoice',
        value: 'buyer_invoice',
        categories: [
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'delivery_date',
                label: 'Delivery date',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'unit_price',
                label: 'Unit Price',
            },
            {
                value: 'qty',
                label: 'QTY',
            },
            {
                value: 'invoice_amount',
                label: 'Invoice Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend My Payment Confirmation',
        label: 'Amend My Payment Confirmation',
        value: 'buyer_payment_confirmation',
        categories: [
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'currency',
                label: 'Currency',
            },
            {
                value: 'amount',
                label: 'Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Amend Supplier Invoice',
        label: 'Amend Supplier Invoice',
        value: 'supplier_invoice',
        categories: [
            {
                value: 'wrong_file_uploaded',
                label: 'Wrong file uploaded',
            },
            {
                value: 'address',
                label: 'Address',
            },
            {
                value: 'due_date',
                label: 'Due date',
            },
            {
                value: 'currency',
                label: 'Currency',
            },
            {
                value: 'qty',
                label: 'QTY',
            },
            {
                value: 'invoice_amount',
                label: 'Invoice Amount',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Create RFQ',
        label: 'Create RFQ',
        value: 'rfq',
        categories: [],
    },
    {
        request_type: 'Credit Limit Extension',
        label: 'Credit Limit Extension',
        value: 'credit_limit_extension',
        categories: [],
    },
    {
        request_type: 'Deal Financing',
        label: 'Deal Financing',
        value: 'deal_financing',
        categories: [],
    },
    {
        request_type: 'Payable Financing',
        label: 'Payable Financing',
        value: 'payable_financing',
        categories: [],
    },
    {
        request_type: 'Query',
        label: 'Query',
        value: 'query',
        categories: [],
    },
    {
        request_type: 'Raise a Dispute - Cancel Transaction',
        label: 'Raise a Dispute - Cancel Transaction',
        value: 'order_cancellation',
        categories: [
            {
                value: 'eta_change',
                label: 'ETA Change',
            },
            {
                value: 'route_change',
                label: 'Route Change',
            },
            {
                value: 'other',
                label: 'Other',
            },
        ],
    },
    {
        request_type: 'Raise a Dispute - Quality',
        label: 'Raise a Dispute - Quality',
        value: 'quality',
        categories: [
            {
                value: 'product_type',
                label: 'Product Name',
            },
        ],
    },
    {
        request_type: 'Raise a Dispute - Quantity',
        label: 'Raise a Dispute - Quantity',
        value: 'quantity',
        categories: [
            {
                value: 'product_type',
                label: 'Product Name',
            },
        ],
    },
    {
        request_type: 'Request Ad-hoc Report',
        label: 'Request Ad-hoc Report',
        value: 'adhoc_report',
        categories: [],
    },
];
